<template>
  <app-timeline-item variant="success" :author="true">
    <template v-slot:author>
      <b-avatar
        v-if="comment.author"
        size="40px"
        variant="primary"
        class="pull-up"
        :title="comment.author ? comment.author.first_name : ''"
        :src="comment.author.photo"
      />
      <b-avatar v-else v-b-tooltip.hover class="pull-up" title="222" />
    </template>
    <div>
      <h6>
        <b-link href="#">{{ comment.author.first_name || "" }}</b-link>
        <small class="text-muted ml-1">{{
          dateFormat(comment.created_date)
        }}</small>
      </h6>
    </div>

    <p class="comment">{{ comment.message }}</p>

    <div v-if="Array.isArray(comment.files)">
      <b-row class="mb-1">
        <b-col
          class="mb-50 cursor-pointer"
          md="3"
          v-for="file in comment.files"
          :key="file.id"
          @click="$emit('openFilePreview', file.file_full)"
        >
          <b-img :src="file.file_full" class="img__card" />
        </b-col>
      </b-row>
    </div>

    <!-- <div>
      <span
        class="text-muted mr-1 cursor-pointer"
        @click="$emit('deleteComment', comment)"
        >{{$t('delete')}}</span
      >
      <span
        class="text-muted cursor-pointer"
        v-if="reply"
        @click="$emit('replyComment', comment)"
      >
        Ответить
      </span>
    </div> -->

    <!-- <div class="pt-50" v-if="comment.children">
      <small v-if="comment.children.length">
        <b-link @click="collapse = !collapse">
          <feather-icon
            :icon="collapse ? 'ChevronUpIcon' : 'ChevronDownIcon'"
          />
          Показать {{ comment.children.length }} ответов
        </b-link>
      </small>

      <app-timeline v-if="collapse" class="mt-1">
        <CommentsItem
          v-for="commentChild in comment.children"
          :key="commentChild.id"
          :reply="false"
          :comment="commentChild"
          @deleteComment="$emit('deleteComment', commentChild)"
        />
      </app-timeline>
    </div> -->

    <hr v-if="line" />
  </app-timeline-item>
</template>

<script>
import { BLink, BAvatar, BRow, BCol, BImg } from "bootstrap-vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import moment from "moment";

export default {
  name: "CommentsItem",
  props: {
    comment: {
      type: Object,
      required: true,
    },
    reply: {
      type: Boolean,
      required: false,
      default: true,
    },
    line: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      collapse: false,
    };
  },
  methods: {
    dateFormat(date) {
      return moment(date, 'YYYY-MM-DD', this.$i18n.locale).fromNow();
    },
  },
  mounted() {
    // moment.locale(this.$getLang);
  },
  components: {
    AppTimeline,
    AppTimelineItem,
    BAvatar,
    BLink,
    BRow,
    BCol,
    BImg,
  },
};
</script>

<style scoped>
.comment {
  max-width: 90%;
}

.img__card {
  height: 100px;
  width: 100%;
  object-fit: contain;
}
</style>
